import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useAppDispatch } from "app/hooks";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { useLocation, useNavigate } from "react-router-dom";
import { updateImportedAchievements } from "reduxState/achievements/achievements";
import { updateImportedGlobalAchievements } from "reduxState/globalManagement/globalManagement";
import { backendErrors } from "utilities/backendErrors";
import { links } from "utilities/links";
import { AchievementForm } from "../AchievementForm/AchievementForm";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formWrapper: {
      maxWidth: "1300px",
      width: "100%",
      margin: `${theme.spacing(8)} auto 0`,
    },
  }),
);

export const EditImportedAchievement = () => {
  const { message } = useMessage();
  const { state } = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const classes = useStyles();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "achievementsImportReview" }),
      path: links.achievementsImportList,
    },
  };

  const initialValues = state.achievementData;
  const clearLink =
    state?.importType === "single"
      ? links.campaignsImportList
      : links.configDuplicationImport;

  return (
    <>
      <TopHeader
        title={state?.achievementData?.name}
        clearLink={clearLink}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.formWrapper}>
        <AchievementForm
          initialValues={initialValues}
          initialErrors={backendErrors(state.errors)}
          onSaveCallback={(achievement) => {
            // SINGLE IMPORT
            if (state?.importType === "single") {
              dispatch(
                updateImportedAchievements({
                  importedId: state.importedId,
                  achievement: achievement,
                }),
              );

              return navigate(links.achievementsImportList);
            }
            // GLOBAL IMPORT UPDATE
            dispatch(
              updateImportedGlobalAchievements({
                importedId: state.importedId,
                achievement: achievement,
              }),
            );
            return navigate(links.configDuplicationImport);
          }}
          onCancelCallback={() => {
            if (state?.importType === "single") {
              return navigate(links.achievementsImportList);
            }
            return navigate(links.configDuplicationImport);
          }}
        />
      </div>
    </>
  );
};
